/* ============================================================
   Article contents list.

   Builds the "On this page" rail from the article's own h2s. It has to happen
   client-side: the body is merchant-written HTML pasted into Shopify, so there
   is no structured outline to read server-side.

   The markup ships hidden and this unhides it — so an article with too few
   headings shows nothing rather than a contents list of one item. Same rule as
   the rest of the site: a section with nothing to say does not appear.

   No framework, no dependencies, one IntersectionObserver.
   ============================================================ */
(function () {
  'use strict';

  // Below this, a contents list is not worth the space it takes.
  var MIN_HEADINGS = 3;

  function slugify(text, index) {
    var base = text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
    return base ? base : 'section-' + index;
  }

  function build() {
    var toc = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    var content = document.querySelector('.dw-article__content');
    if (!toc || !list || !content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) return;

    var seen = {};
    var links = [];

    headings.forEach(function (h, i) {
      // Respect an id the merchant already set — it may be linked from elsewhere.
      if (!h.id) {
        var id = slugify(h.textContent || '', i);
        // Two headings can legitimately share a title ("Step one" in two guides
        // pasted together); a duplicate id would send both links to the first.
        while (seen[id]) id = id + '-' + i;
        h.id = id;
      }
      seen[h.id] = true;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    toc.hidden = false;

    // ---- active state ----------------------------------------------------
    // rootMargin pulls the trigger line to ~1/4 down the viewport, so a heading
    // counts as "current" once it is comfortably on screen rather than the
    // instant its top pixel crosses the fold.
    if (!('IntersectionObserver' in window)) return;

    var current = null;

    function setActive(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      // Several headings can be on screen at once; the one nearest the top of
      // the reading area wins. Sorting by position beats trusting entry order.
      var visible = entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
      if (visible.length) setActive(visible[0].target.id);
    }, {
      rootMargin: '-25% 0px -65% 0px',
      threshold: 0
    });

    headings.forEach(function (h) { observer.observe(h); });

    // Clicking a link should land the heading below the sticky header rather
    // than under it. scroll-margin-top on the headings handles that in CSS, so
    // native anchor behaviour is left alone — no scroll hijacking, and the URL
    // still updates so the position is shareable.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
